import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import BodyContentType from 'owa-service/lib/contract/BodyContentType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import emailAddressWrapperToAttendeeType from '../utils/emailAddressWrapperToAttendeeType';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { default as displayNewAppointment } from 'owa-calendar-compose-form-store/lib/utils/displayNewAppointmentForm';
import {
    createEnhancedLocationsFromPersonaControlViewState,
    createLocationPersonaFromStringLocation,
} from 'owa-location-persona';

export const displayNewAppointmentForm = (event: CalendarEvent) => (
    requiredAttendees?: EmailAddressWrapper[],
    optionalAttendees?: EmailAddressWrapper[],
    start?: number,
    end?: number,
    location?: string,
    resources?: string[],
    subject?: string,
    body?: string
) => {
    const required = emailAddressWrapperToAttendeeType(requiredAttendees);
    const optional = emailAddressWrapperToAttendeeType(optionalAttendees);
    const startTime = start ? new Date(start) : null;
    const endTime = end ? new Date(end) : null;
    let enhancedLocation: EnhancedLocation;
    if (location) {
        const viewstate = createLocationPersonaFromStringLocation(location);
        enhancedLocation = createEnhancedLocationsFromPersonaControlViewState(viewstate)[0];
    }

    const convertedResources = resources
        ? resources.map(res => {
              return <AttendeeType>{
                  Mailbox: { EmailAddress: res },
              };
          })
        : null;
    const bodyContent: BodyContentType = {
        Value: body,
        BodyType: 'HTML',
    };

    displayNewAppointment(
        event.ParentFolderId,
        required,
        optional,
        startTime,
        endTime,
        enhancedLocation,
        convertedResources,
        subject,
        bodyContent
    );
};
